import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import { useTranslate } from "ra-core";
import { useEditFileSystemNodeTagsDialog } from "../dialogs/edit-file-system-node-tags-dialog/EditFileSystemNodeTagsDialogProvider";

const EditFileSystemNodeTagsButton = (props) => {
    const { onClick, fileSystemNodePath } = props;
    const translate = useTranslate();
    const dialog = useEditFileSystemNodeTagsDialog();
    const handleOnClick = () => {
        dialog.open(fileSystemNodePath);
        onClick();
    }
    return (
        <ListItem button onClick={handleOnClick}>
            <ListItemIcon>
                <LocalOfferIcon/>
            </ListItemIcon>
            <ListItemText primary={translate(`cmss.resources.file-explorer.directory-actions-menu.buttons.edit-tags`)} />
        </ListItem>
    ) 
};
export default EditFileSystemNodeTagsButton;
